/** @module Camunda/_ToolbarSelectMixin */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/store/Memory",
	"underscore",
	"csi/locale",
	"csi/view/ToolbarSimpleSelect"
], function(declare, lang, Memory, _, locale, ToolbarSimpleSelect) {
	const ACTION_FIND = "CamundaInstanceFilter";

	return declare(null, {
		disableCustomViewToolbar: true,

		/** @property {string[]} camundaFilterValues - the array to create the store for the select */
		camundaFilterValues: null,

		/** @property {string[]} camundaLocationFilterValue - possible Filter key values, order of values match camundaFilterValues  */
		camundaLocationFilterValue: null,

		/** @property {string} camundaFilterValue - selected filter */
		camundaFilterValue: "",

		/**
		 * @override
		 * Specify toolbar plugins for process instance searching
		 */
		postMixInProperties: function() {
			const defView = this.defView;

			const store = new Memory({
				data: _.map(this.camundaFilterValues, function(id) {
					return {id: id, name: locale.resource(id)};
				})
			});

			this.plugins = [
				defView._addViewAction(ACTION_FIND, {
					classToolbarPlugin: ToolbarSimpleSelect,
					classToolbarPluginParams: {
						store: store,
						labelAttr: "name",
						sortByLabel: false,
						value: this.camundaFilterValue
					},
					m_class: "csi-toolbar-select-200 csi-toolbar-spacing",
					m_onAction: "_onActionProcessFilter",
					m_postAction: "postActionRefresh"
				}),
				"filter",
				"refresh",
				"|",
				"pageSize"
			];

			this.inherited(arguments);
		},

		/**
		 * Set filter selection
		 * @param {Controller} ac
		 */
		_onActionProcessFilter: function(ac) {
			this.camundaFilterValue = ac.actionValue;
		}
	});
});